import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';
import routes from '../utils/variables/routes';
import { decryptUrlParam, isValidHttpUrl } from '../utils/functions';
import { validateAuth } from '../hooks/useAuth';
import { useFeatureToggle, useRouter, useVariables } from '../hooks';
import { dutchTemplate } from '../utils/variables';

export default function UnauthenticatedRoute({ component: C, appProps, ...rest }) {
  const { isAuthenticated } = useSelector(state => validateAuth(state));
  const redirect = useSelector(state => state?.misc?.redirectUrl);
  const { redirect: urlRedirect, re: redirectEncrypt } = useRouter()?.query;
  const variables = useVariables();
  const doFeatureToggle = useFeatureToggle();
  // const useFatumLogin = doFeatureToggle('useFatumLogin');

  const userType = useSelector(state => state.auth.usertype);
  // let redirect = validateCredentialsResponse?.redirect;
  const signOutRoute = routes.account.signOut;

  let newRedirect = urlRedirect || redirect;
  if (redirectEncrypt) {
    newRedirect = decryptUrlParam(redirectEncrypt);
  }
  if (
    (newRedirect && newRedirect?.toString()?.startsWith(routes.auth.index)) ||
    newRedirect === signOutRoute
  ) {
    newRedirect = routes.portfolio.portfolioSummary;
  }
  if (
    userType === 'agent' ||
    (variables?.templateName === dutchTemplate && !newRedirect)
  ) {
    newRedirect = routes.home;
  }

  const RedirectToExternal = ({ url }) => {
    useEffect(() => {
      // Use replace() for cleaner history, so the user doesn't get stuck in a redirect loop
      setTimeout(() => {
        window.location.href = url;
      }, 500);
    }, [url]); // The effect runs whenever the 'url' prop changes

    return <h5>Redirecting, Please wait ...</h5>; // Display a message while redirecting
  };

  return (
    <Route
      {...rest}
      render={props =>
        !isAuthenticated ? (
          <C {...props} {...appProps} />
        ) : newRedirect && newRedirect.length > 0 && isValidHttpUrl(newRedirect) ? (
          <RedirectToExternal url={newRedirect} />
        ) : (
          <Redirect to={newRedirect || routes.portfolio.portfolioSummary} />
        )
      }
    />
  );
}
